export const seoConstants = {
	domain: 'https://www.litto.co/',
	name: 'Litto',
	legalName: 'Litto d.o.o',
	mainTitle:
		'LITTO | Book apartments, luxury villas and vacation rentals in Croatia',
	mainDescription:
		'Best price guaranteed! Schedule your Croatia holiday with Litto and discover unforgettable holiday experiences on the Adriatic coast.'
};
